import { render, staticRenderFns } from "./AvatarToken.vue?vue&type=template&id=aa43d952&scoped=true&"
import script from "./AvatarToken.vue?vue&type=script&lang=js&"
export * from "./AvatarToken.vue?vue&type=script&lang=js&"
import style0 from "./AvatarToken.vue?vue&type=style&index=0&id=aa43d952&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa43d952",
  null
  
)

export default component.exports